export default __webpack_public_path__ + "static/media/Opposites01_11.57f7af42.png";